import { message } from 'antd';
import { saveAs } from 'file-saver';
// import { resouseDownloadHelper } from 'common/help/resouseDownloadHelper';

export function download(url: string, fileName: string, subject: string, uuid: string) {
  alo7Api
    .fetch(alo7Api.prefix.host + `/api/v1/resources_${subject}/${uuid}/download`, {
      method: 'PUT',
    })
    .then(responseData => {
      saveAs(responseData.url, fileName);
      // window.open(responseData.url, '_blank');
      // window.fetch(responseData.url, { cache: 'no-cache' }).then(res => {
      //   const { url } = res;
      //   resouseDownloadHelper(url, fileName);
      // });
    })
    .catch(error => message.error('下载失败：' + error.message));
}
